export const navLinks = [
  { label: '首页', path: '/' },
  { label: '足球', path: '/category/football' },
  { label: '篮球', path: '/category/basketball' },
  { label: '网球', path: '/category/tennis' },
  { label: '电竞', path: '/category/esports' },
  { label: '综合', path: '/category/others' },
  { label: '关于我们', path: '/about' },
];